import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface AuditLogApiItem {
  _id: string;
  action: string;
  module: string;
  actor_user_id?: string | null;
  actor_user_name?: string | null;
  target_user_id?: string | null;
  target_user_name?: string | null;
  entity_type?: string | null;
  entity_id?: string | null;
  details?: string | null;
  old_values?: Record<string, unknown> | null;
  new_values?: Record<string, unknown> | null;
  ip_address?: string | null;
  user_agent?: string | null;
  meta?: {
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    created_by?: string;
    updated_by?: string;
    created_by_id?: string;
    updated_by_id?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface AuditLogsResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    auditLogs?: AuditLogApiItem[];
    count?: number;
  };
}

export const getAuditLogs = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  action?: string;
  module?: string;
  from_date?: string;
  to_date?: string;
  'meta.status'?: 'active' | 'inactive';
}): Promise<AuditLogsResponse> => {
  return api.get<AuditLogsResponse>(API_ENDPOINTS.auditLogs.list, { params });
};
